import { sortBy } from 'lodash';
import { createSelector } from 'reselect';
import { isBot } from '@meiqia/utils';

const agentInPerm = (agent, inPermAgent) => {
  const { privilege_range: mePriviedgeRange, id } = inPermAgent;
  let notInPerm = false;
  if (mePriviedgeRange === 'self') {
    notInPerm = id !== agent.id;
  } else if (mePriviedgeRange === 'all') {
    notInPerm = false;
  } else {
    notInPerm = true;
    if (Array.isArray(mePriviedgeRange)) {
      mePriviedgeRange.forEach(v => {
        if (v === agent.group_id) {
          notInPerm = false;
        }
      });
    }
    if (id === agent.id) {
      notInPerm = false;
    }
  }
  return !notInPerm;
};

const inConditionAllAgent = (agent, agentInfo, conditions) => {
  const condition = {
    bot: () => isBot(agent.privilege),
    notBot: () => !isBot(agent.privilege),
    notSmartGuideBot: () => agent.privilege !== 'bot:smartguide',
    notMarketingBot: () => agent.privilege !== 'bot:mpush',
    withSip: () => !!agent.sip_id,
    withoutSip: () => !agent.sip_id,
    deleted: () => !agent.email || agent.deleted_at,
    notDeleted: () => agent.email && !agent.deleted_at,
    onLine: () => agent.is_online,
    onLineOrBot: () => agent.is_online || agent.privilege === 'bot',
    notMe: () => {
      const { id } = agentInfo;
      return id !== agent.id;
    },
    onlyWithExBot: () =>
      agent.privilege !== 'bot' && agent.privilege !== 'bot:smartguide' && agent.privilege !== 'bot:mpush', // 只包含外部机器人 bot:ex
    inPerm: agent => agentInPerm(agent, agentInfo), // 他人在agent权限里面
    inOthersPerm: agent => agentInPerm(agentInfo, agent) // agent在他人权限里面
  };

  return conditions.every(c => condition[c](agent));
};

const filterAgents = (agents, meInfo, conditions) => {
  return agents.filter(agent => inConditionAllAgent(agent, meInfo, conditions));
};

const makeFilterAgent = () => {
  return createSelector(
    [agentList => agentList, (agentList, type) => type, (agentList, type, agentInfo) => agentInfo],
    (agentList, type, agentInfo) => {
      let agents = [];
      switch (type) {
        case 'active':
          agents = agentList.filter(data => data.is_online);
          break;
        case 'offline':
          agents = agentList.filter(data => !data.is_online && data.status === 'off_duty');
          break;
        case 'online':
          agents = agentList.filter(data => !data.is_online && data.status !== 'off_duty');
          break;
        case 'withSipAndEffective':
          agents = filterAgents(agentList, agentInfo, ['withSip', 'notDeleted', 'notBot']);
          break;
        case 'withoutSipAndEffective':
          agents = filterAgents(agentList, agentInfo, ['withoutSip', 'notDeleted', 'notBot']);
          break;
        case 'mention':
          agents = filterAgents(agentList, agentInfo, ['onLine', 'notMe', 'notDeleted', 'notBot']);
          agents = sortBy(agents, agent => agent.status === 'off_duty');
          break;
        case 'ticketAgent':
          agents = filterAgents(agentList, agentInfo, ['notDeleted']);
          break;
        case 'redirect':
          agents = filterAgents(agentList, agentInfo, ['onLine', 'notDeleted', 'notBot']);
          break;
        case 'filter':
          agents = filterAgents(agentList, agentInfo, [
            'inPerm',
            // 'onLine',
            'notDeleted',
            'notMe'
            // 'notSmartGuideBot',
            // 'notMarketingBot'
          ]);
          break;
        case 'perm':
          agents = filterAgents(agentList, agentInfo, ['inPerm']);
          break;
        case 'permNotDeleted':
          agents = filterAgents(agentList, agentInfo, ['inPerm', 'notDeleted']);
          break;
        case 'notDeleteWithoutRobot':
          agents = filterAgents(agentList, agentInfo, ['notDeleted', 'notBot']);
          break;
        case 'agentWithGroup':
          agents = filterAgents(agentList, agentInfo, ['inPerm', 'notDeleted', 'notBot']);
          break;
        case 'notDeleteOrRobot':
          agents = filterAgents(agentList, agentInfo, ['notDeleted', 'notBot']);
          break;
        case 'inspectionFilter':
          agents = filterAgents(agentList, agentInfo, ['inPerm', 'notDeleted']);
          break;
        case 'homeTable':
          agents = filterAgents(agentList, agentInfo, ['inPerm', 'notDeleted']);
          break;
        case 'smartGuide':
          agents = filterAgents(agentList, agentInfo, ['notDeleted', 'notBot']);
          break;
        case 'notBot':
          agents = filterAgents(agentList, agentInfo, ['notBot']);
          break;
        case 'notDeleteWithExRobot':
          agents = filterAgents(agentList, agentInfo, ['notDeleted', 'onlyWithExBot']);
          break;
        default:
          agents = [];
      }
      return agents;
    }
  );
};

export default makeFilterAgent;
